<template>
  <el-menu
    :collapse="collapsed"
    collapse-transition
    :default-active="defaultActive"
    class="el-menu-vertical-demo"
    background-color="#334157"
    text-color="#fff"
    @select="hanldeSelect"
    active-text-color="#ffd04b"
  >
    <div class="logobox" @click="handleHome">
      <img style="width: 60px; height: auto" src="../assets/logo.png" />
      <span v-if="!collapsed">银行汇票管理系统</span>
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.id" :index="menu.id + ''">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{ menu.name }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item
          v-for="chmenu in menu.children"
          :index="chmenu.id + ''"
          :key="chmenu.id"
        >
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{ chmenu.name }}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>

<script>
import { navMenu } from "@/api/system/menu";
import { getMenu } from "@/utils";

export default {
  name: "leftnav",
  data() {
    return {
      defaultActive: "",
      collapsed: false,
      allmenu: [],
    };
  },
  created() {
    this.$root.Bus.$on("toggle", (value) => {
      this.collapsed = !value;
    });
    this.getData();
  },
  methods: {
    getData() {
      navMenu()
        .then((data) => {
          if (data && data.length) {
            this.allmenu = data
              .filter((menu) => menu.url !== "/ticket/capture")
              .map((menu) => {
                let list = menu.list;
                delete menu.list;
                menu.children = list;
                return menu;
              });
            this.defaultActive = `${this.allmenu[0].id}`;
          }
        })
        .catch(() => {
          this.$message.error("菜单加载失败，请稍后再试！");
        });
    },
    handleHome() {
      this.$router.push({ path: "/", replace: true });
    },
    hanldeSelect(index) {
      const currentMenu = getMenu(this.allmenu, (data) => {
        return data.id === parseInt(index);
      });
      // 0 目录， 1 菜单，2 按钮
      if (this.$route.path !== currentMenu.url) {
        this.$router.push(currentMenu.url);
      }
    },
  },
};
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  display: flex;
  height: 60px;
  line-height: 60px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: left;
  padding: 20px 0px;
  cursor: pointer;
}
.logobox img {
  margin: 0 6px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue